import { EventType } from "./events";
import { getLocalStorageValue } from "./local-storage";

export const emitEvent = (
  commandName: EventType,
  data: Record<string, unknown> | undefined,
  isSpaEvent: boolean
) => {
  const sendData = data ? { ...data } : {};

  if (!("gaClientId" in sendData)) {
    const gaClientId = getLocalStorageValue("ga:clientId");

    if (!!gaClientId) {
      sendData.gaClientId = gaClientId;
    }
  }

  if (window?.dataLayer) {
    const gtmEvent = { event: commandName, ...sendData };

    window.dataLayer.push(gtmEvent);
  }

  if (window._jts) {
    const jtsEvent = { track: commandName, ...sendData };

    window._jts.push(jtsEvent, isSpaEvent);
  }
};
